/**
 * Copyright (c) 2021-22 Amway
 * @author Charu Agrawal
 */

import _ from "lodash";
/**
 * This method is used to set the options list from contentstack
 * @param {Object} optionsList
 *
 */

// export const getOptionsList = (optionsList: Object) => {
//   const optionsArray: Array<Object> = [];
//   _.forEach(_.entries(Object(optionsList)), ([key, value]) => {
//     let Obj: any = {};
//     _.forEach(_.entries(Object(value)), ([key, value]) => {
//       _.forEach(Array(value),(element: any) => {
//         const displayValue= element.find((x: any) => x.key === "display-value")
//         const recommKey = element.find((x: any) => x.key === "recomm-key")
//         const lifeomicKey = element.find((x: any) => x.key === "lifeomic-key")
//         const textEnable = element.find((x: any) => x.key === "isVisible")
//         Obj.value = displayValue && displayValue.value;
//         Obj.id = recommKey && recommKey.value;
//         Obj.lifeomic = lifeomicKey && lifeomicKey.value;
//         Obj.isVisible = textEnable && textEnable.value;
//         optionsArray.push(Obj);
//       });
//     });
//   });
//   return optionsArray;
// };

/**
 * This method is used to set the updated options list from contentstack
 * @param {Object} optionsList
 *
 */

export const getUpdatedOptionsList = (optionsList: Object) => {
  const optionsArray: Array<Object> = [];
  _.forEach(_.entries(Object(optionsList)), ([key, value]: any) => {
    // let Obj: any = {};
    const Obj: any = {
      value: value[0],
      id: value[1],
      lifeomic: value[2],
      isVisible: value[3],
      ...(value[4] && { needStateId: value[4] }),
      ...(value[5] && { imageSrc: value[5] }),
      ...(value[6] && { isMandatory: value[6] }),
    };
    // Obj.value = data[0];
    // Obj.id = data[1];
    // Obj.lifeomic = data[2];
    // Obj.isVisible = data[3];
    // Obj.needStateId = data[4] ? data[4] : "";
    optionsArray.push(Obj);
  });
  return optionsArray;
};
